import React, {useState} from "react"
import * as Yup from "yup"
import {connect} from "react-redux"
import {useForm} from "react-hook-form"
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from "reactstrap"


// components
import SelectGeneric from "../../../components/select/selectGeneric";
import {ButtonCancel,  ButtonSubmit} from "../../../components/buttons/buttonsActions"

// labels
import {
    FORM, LB_AIRLINE, LB_AIRPORT, LB_DESTINY,
    LB_ORIGIN, LB_SALESFORCE_ID,
    LB_SELECT_SERVICE, REQUIRED, UDN
} from "../../../components/i18n/i18n"

// actions
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions"

// services
import {genericActions} from "../../../redux/actions/generics/GenericActions"
import {wishlistSalesforceService} from "../../../jwt/_services/salesforce/wishlistSalesforceService"

// providers
import {wishlistServiceProvider} from "../../../providers/wishlist/wishlistServicesProvider";
import {udnProvider} from "../../../providers/udnProvider";
import {airlineProvider} from "../../../providers/airlineProvider";

// utils
import {wishlistTypes} from "../../../util/WishlistUtils";
import {airportProvider} from "../../../providers/hotel/airportProvider";




const WishlistSalesforceForm = (props) => {
    const { app } = props.mainProps;
    const { editMode, domainObject } = props.formProps;

    const fbDataBase = {id: app?.fbDataBase?.id}

    const [servicio, setServicio] = useState(domainObject?.servicio || null);
    const [idOrigen, setIdOrigen] = useState(domainObject?.origen?.id || null);
    const [idDestino, setIdDestino] = useState(domainObject?.destino?.id || null);

    const validationSchema = Yup.object().shape({
        idSalesforce: Yup.string().required(REQUIRED),
    });

    const { register, handleSubmit, reset } = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            idSalesforce: domainObject?.idSalesforce,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            fbDataBase,
            item : {
                ...data,
                servicio,
                idOrigen,
                idDestino,
            }
        };

        if (!editMode)
            genericActions.save(wishlistSalesforceService, dataRequest)
        else {
            let id = domainObject.id;
            dataRequest.item.id = id

            genericActions.update(wishlistSalesforceService, id, dataRequest)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return <Card className={'card-modal'}>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-edit mr-2"/>{FORM}
        </CardTitle>
        <CardBody className={'card-body-modal'}>
            {
                !servicio ? <>
                    <Row>
                        <Col>
                            <FormGroup>
                                <div className={'wl-modal-title'}>{LB_SELECT_SERVICE}</div>
                                <SelectGeneric
                                    provider={ wishlistServiceProvider }
                                    initialValue={ servicio }
                                    setExternalValue={ setServicio }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <div>
                                <ButtonCancel onClick={ closeForm }/>
                            </div>
                        </Col>
                    </Row>
                </>
                : <Form onSubmit={ handleSubmit(onSubmit) }>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{UDN} ({LB_ORIGIN})</Label>
                                <SelectGeneric
                                    provider={ udnProvider }
                                    initialValue={ idOrigen }
                                    setExternalValue={ setIdOrigen }
                                />
                            </FormGroup>
                        </Col>
                        {
                            servicio === wishlistTypes.transportation.description
                            ? <Col>
                                    <FormGroup>
                                        <Label>{LB_AIRPORT} ({LB_DESTINY})</Label>
                                        <SelectGeneric
                                            provider={ airportProvider }
                                            initialValue={ idDestino }
                                            setExternalValue={ setIdDestino }
                                        />
                                    </FormGroup>
                                </Col>
                            : <Col>
                                    <FormGroup>
                                        <Label>{UDN} ({LB_DESTINY})</Label>
                                        <SelectGeneric
                                            provider={ udnProvider }
                                            initialValue={ idDestino }
                                            setExternalValue={ setIdDestino }
                                        />
                                    </FormGroup>
                                </Col>
                        }
                    </Row>

                    <Row>
                        <Col>
                            <FormGroup>
                                <Label>{LB_SALESFORCE_ID}</Label>
                                <Input
                                    name="idSalesforce"
                                    innerRef={register}
                                    placeholder={LB_SALESFORCE_ID}
                                    defaultValue={domainObject?.idSalesforce}
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="d-flex justify-content-center">
                            <div>
                                <ButtonSubmit/>
                                <ButtonCancel onClick={ closeForm }/>
                            </div>
                        </Col>
                    </Row>
                </Form>
            }
        </CardBody>
    </Card>
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(WishlistSalesforceForm);